if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;

	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"index": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises) {
	var cssChunks = {
"components_src_autoComplete_style_scss-components_src_phoneInput_style_scss": 1,
"components_src_img_cc-light_png-components_src_modal_index_tsx-components_src_selectField_ind-cdab63": 1,
"src_pages_accounts_Accounts_tsx-components_src_autoComplete_style_scss-components_src_datePic-dabf4e": 1,
"src_pages_ai-hub_AIHubBidAnalysis_tsx-components_src_dropzone_style_scss-components_src_infin-e216e8": 1,
"src_pages_ai-hub_AIHubConceptCheck_tsx-components_src_autoComplete_style_scss-components_src_-1583ab": 1,
"src_pages_ai-hub_AIHubEstimateReview_tsx-components_src_dropzone_style_scss-components_src_in-8fd615": 1,
"src_pages_ai-hub_AIHubQaQc_tsx-components_src_dropzone_style_scss-components_src_infiniteScro-e25132": 1,
"src_pages_ai-hub_AIHubRootCauseTracker_tsx-components_src_infiniteScroll_style_scss": 1,
"src_pages_ai-hub_chat_AIChatThread_tsx-src_pages_ai-hub_chat_AIChatTextField_scss": 1,
"src_pages_ai-hub_chat_AIChatWelcome_tsx-src_pages_ai-hub_chat_AIChatTextField_scss": 1,
"src_pages_ai-hub_index_tsx-components_src_pdfViewer_style_scss": 1,
"src_pages_ai-hub_wizard_WizardStepAsk_tsx-src_pages_settings_index_tsx-services_src_api_purch-dd7172": 1,
"src_pages_analytics_ClientDashboard_scss": 1,
"src_pages_analytics_ClientsDirectory_tsx-components_src_accountPeerList_style_scss": 1,
"src_pages_analytics_ContractorDashboard_scss-src_pages_analytics_ProjectTypeDonut_scss": 1,
"src_pages_analytics_ContractorDashboard_tsx-components_src_dropzone_style_scss": 1,
"src_pages_analytics_EnterpriseDashboard_tsx-src_pages_analytics_PipelineBar_scss": 1,
"src_pages_analytics_Home_tsx-src_pages_analytics_PipelineBar_scss-src_pages_analytics_Project-9bb023": 1,
"src_pages_dashboard_Dashboard_tsx": 1,
"src_pages_error_AccountCanceling_tsx": 1,
"src_pages_error_AccountClosed_tsx": 1,
"src_pages_error_NotFound_tsx": 1,
"src_pages_invite_Complete_tsx": 1,
"src_pages_invite_Verify_tsx": 1,
"src_pages_layout_dashboard_useBottomActionBar_ts-src_pages_projects_common_PhaseModal_tsx-src-1e32e3": 1,
"src_pages_offices_create_OfficeCreate_tsx": 1,
"src_pages_offices_edit_index_tsx": 1,
"src_pages_offices_list_index_tsx": 1,
"src_pages_onboarding_Onboarding_tsx-components_src_cardSelect_style_scss-components_src_dropz-b9d11d": 1,
"src_pages_payment-issue_index_tsx-src_pages_settings_payments_saved-cards-modal_scss-componen-645ee8": 1,
"src_pages_projects_edit_index_tsx-src_pages_settings_payments_saved-cards-modal_scss-componen-caf850": 1,
"src_pages_projects_list_index_tsx-components_src_datePicker_style_scss": 1,
"src_pages_projects_new_index_tsx-components_src_autoComplete_style_scss-components_src_datePi-de1282": 1,
"src_pages_providers_ProvidersPage_tsx": 1,
"src_pages_settings_InvitationList_tsx-src_pages_settings_InviteProviderModal_tsx-components_s-c2c46e": 1,
"src_pages_transactions_index_tsx-components_src_datePicker_style_scss": 1,
"vendors-node_modules_pnpm_react-phone-input-2_2_15_1_react-dom_19_2_3_react_19_2_3__react_19_-6a720e": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

var oldTags = [];
var newTags = [];
var applyHandler = function (options) {
	return {
		dispose: function () {
			for (var i = 0; i < oldTags.length; i++) {
				var oldTag = oldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			oldTags.length = 0;
		},
		apply: function () {
			for (var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
			newTags.length = 0;
		}
	}
}
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if (!oldTag) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = createStylesheet(
				chunkId,

				/**
					If dynamically add link tag through dom API and there is already a loaded style link, browsers sometimes treats the new link tag as the same link, and won't fetch the new style.
					Use query to avoid browser cache the link tag, force to re-fetch new style, this is the same strategy as updateCss API, this can happen during lazy compilation
				 */
				`${fullhref}?${Date.now()}`,
				oldTag,
				function () {
					tag.as = "style";
					tag.rel = "preload";
					resolve();
				},
				reject
			);
			oldTags.push(oldTag);
			newTags.push(tag);
		}))
	});
}

// no prefetch
// no preload